import { IconDragHandle24 } from '@dhis2/ui-icons';
import React from 'react';
import { TableDataCell } from '../table-elements/index.js';
export const DragHandleCell = () => /*#__PURE__*/React.createElement(TableDataCell, {
  width: "48px"
}, /*#__PURE__*/React.createElement(IconDragHandle24, null));